import { SELECT_HIGHCHARTS_TYPE, UPDATE_ACTIVE_DATA_VIEW_ITEM } from './actionTypes';
import { ActiveMenuItemEnum } from './types';
// import type { ReportAction, ReportsHighchartState } from './types';

const getSeriesForView = (activeView) => [
  {
    title: {
      text: '# of Events',
    },
  },
  {
    title: {
      text: '% of Total',
    },
    opposite: true,
    max: 100,
    visible: activeView === ActiveMenuItemEnum.dateTimeTable,
  },
];

const defaultActiveView = ActiveMenuItemEnum.componentTable;

const initialState = {
  type: 'Chart',
  selectChartType: [
    { key: 'line', value: 'line', text: 'Line' },
    { key: 'bar', value: 'bar', text: 'Bar' },
    { key: 'column', value: 'column', text: 'Column' },
  ],
  chartType: 'line',
  config: {
    chart: {
      type: 'line',
    },
    title: {
      text: '',
    },
    yAxis: getSeriesForView(defaultActiveView),
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
    },
    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
        pointStart: 0,
      },
    },
    tooltip: {
      split: false,
      shared: true,
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600,
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
            },
          },
        },
      ],
    },
  },
  activeView: defaultActiveView,
};

const reportChartReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_HIGHCHARTS_TYPE:
      return {
        ...state,
        chartType: action.chartType,
        config: {
          ...state.config,
          chart: {
            type: action.chartType,
          },
        },
      };
    case UPDATE_ACTIVE_DATA_VIEW_ITEM:
      return {
        ...state,
        activeView: action.activeView,
        config: {
          ...state.config,
          yAxis: getSeriesForView(action.activeView),
        },
      };
    default: {
      return state;
    }
  }
};

export default reportChartReducer;
